/* 🤖 this file was generated by svg-to-ts */
export const matIconWidthWide: {
  name: 'width-wide';
  data: string;
} = {
  name: 'width-wide',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h2v12H4zm4 0V6h8v12H8zm12 0h-2V6h2v12z"/></svg>`
};
